import classNames from "classnames";
import { get, isEmpty } from "lodash";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { NAME_SPACES } from "shared/locales/constants";
import ActionButtons from "../Components/ActionButtons";
import Header from "../Components/Header";
import Layout from "../Components/Layout";
import DetailsModal from "./DetailsModal";
import UpsellsCard from "./UpsellsCard";

function View({
  onNext,
  onBack,
  upsells,
  selectedModules,
  handleModule,
  projectId,
  insurancePlanId,
}) {
  const { t } = useTranslation(NAME_SPACES.PRIVATE.BROKER.PROJECT);
  const [openDetails, setOpenDetails] = useState(null);

  const DETAIL = t("DETAIL", { returnObjects: true });
  return (
    <Layout>
      <Header
        title="Renforcez votre formule santé grâce à nos <b>surcomplémentaires</b>"
        highlight="Renforcez votre formule santé"
        subtitle="Vos garanties optionnelles"
        onBack={onBack}
      />
      <div className="upsells-wrapper">
        {upsells.map((module) => (
          <UpsellsCard
            key={module?.id}
            notSelected={
              !get(selectedModules, insurancePlanId)?.find(
                ({ insurancePlan }) =>
                  insurancePlan.id === get(module, "insurancePlan.id"),
              )
            }
            name={get(module, "insurancePlan.name") || ""}
            alias={get(module, "insurancePlan.alias") || ""}
            supportingInformation={
              get(module, "insurancePlan.supportingInformation") || []
            }
            cost={get(module, "cost")}
            currency={get(module, "currency")}
            onAdd={() => handleModule({ module })}
            onDetailsClick={() =>
              setOpenDetails(get(module, "insurancePlan.id"))
            }
          />
        ))}
      </div>
      <ActionButtons
        buttonText={"Je souscris"}
        onNext={onNext}
        onBack={onBack}
        disabled={get(selectedModules, insurancePlanId)?.length === 0}
      />
      <div className="mobilityMutual__body--actions">
        <div className={"mobilityMutual-upsells-recap"}>
          <div
            onClick={() => onNext({ ignore: true })}
            className={classNames("mobilityMutual-upsells__item--link", {
              "mobilityMutual-upsells__item--link--hidden": !isEmpty(
                get(selectedModules, insurancePlanId),
              ),
            })}
          >
            Je ne souhaite pas de surcomplémentaire
          </div>
        </div>
      </div>
      {openDetails && (
        <DetailsModal
          centered
          open={openDetails}
          onClose={() => setOpenDetails(null)}
          filter={{
            where: {
              insurancePlan: { id: openDetails },
              project: { id: projectId },
            },
          }}
          translation={DETAIL.TEMPLATES.COMPARISON}
        />
      )}
    </Layout>
  );
}

export default View;
